export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["LOCAL"] = "local";
    AuthProvider["AZURE_AD"] = "azure_ad";
    AuthProvider["AZURE_AD_B2C"] = "azure_ad_b2c";
    AuthProvider["GOOGLE"] = "google";
    AuthProvider["GITHUB"] = "github";
    AuthProvider["OKTA"] = "okta";
    AuthProvider["AUTH0"] = "auth0";
    AuthProvider["CUSTOM_OIDC"] = "custom_oidc";
    AuthProvider["SAML"] = "saml";
    AuthProvider["LDAP"] = "ldap";
})(AuthProvider || (AuthProvider = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MANAGER"] = "MANAGER";
    UserRole["DEVELOPER"] = "DEVELOPER";
    UserRole["VIEWER"] = "VIEWER";
})(UserRole || (UserRole = {}));
export var AuthErrorCode;
(function (AuthErrorCode) {
    AuthErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    AuthErrorCode["USER_NOT_FOUND"] = "USER_NOT_FOUND";
    AuthErrorCode["USER_DISABLED"] = "USER_DISABLED";
    AuthErrorCode["PROVIDER_ERROR"] = "PROVIDER_ERROR";
    AuthErrorCode["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
    AuthErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    AuthErrorCode["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
    AuthErrorCode["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    AuthErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    AuthErrorCode["PROVIDER_NOT_CONFIGURED"] = "PROVIDER_NOT_CONFIGURED";
    AuthErrorCode["INVALID_REDIRECT_URI"] = "INVALID_REDIRECT_URI";
    AuthErrorCode["CSRF_TOKEN_MISMATCH"] = "CSRF_TOKEN_MISMATCH";
})(AuthErrorCode || (AuthErrorCode = {}));
//# sourceMappingURL=auth.js.map